import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import AuthService from '../services/AuthService.js';
import styles from './Login.module.scss';

const Login = () => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkExistingAuth = async () => {
            try {
                // Check if user is already authenticated
                const token = localStorage.getItem('token');
                if (token) {
                    const isValid = await AuthService.verify();
                    if (isValid) {
                        // User is already authenticated, redirect to main page
                        navigate('/', { replace: true });
                        return;
                    } else {
                        // Token is invalid, clear it
                        localStorage.removeItem('token');
                        localStorage.removeItem('premo_password');
                    }
                }
            } catch (error) {
                console.error('Error checking existing auth:', error);
                // Clear any invalid tokens
                localStorage.removeItem('token');
                localStorage.removeItem('premo_password');
            } finally {
                setCheckingAuth(false);
            }
        };

        checkExistingAuth();
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await AuthService.login(password);
            // Redirect to the page they were trying to access, or home
            const from = location.state?.from?.pathname || '/';
            navigate(from, { replace: true });
        } catch (error) {
            console.error('Login error:', error);
            alert('Error: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Show loading while checking existing auth
    if (checkingAuth) {
        return (
            <div className={styles.loginContainer}>
                <div className={styles.loginCard}>
                    <Card title="Premo - Verificando sesión...">
                        <div style={{ textAlign: 'center', padding: '2rem' }}>
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.loginContainer} ${loading ? styles.loadingState : ''}`}>
            <div className={styles.loginCard}>
                <Card title="Premo - Iniciar Sesión">
                    <form onSubmit={handleLogin} className={styles.loginForm}>
                        <div className={styles.formField}>
                            <label htmlFor="password">Contraseña</label>
                            <InputText
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Ingrese su contraseña"
                                disabled={loading}
                                autoComplete="current-password"
                                required
                            />
                        </div>
                        <div className={styles.submitButton}>
                            <Button
                                type="submit"
                                label={loading ? "Iniciando sesión..." : "Iniciar Sesión"}
                                disabled={loading || !password.trim()}
                                loading={loading}
                            />
                        </div>
                    </form>
                </Card>
                {loading && (
                    <div className={styles.loginFooter}>
                        <p>Verificando credenciales...</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;
